import { render, staticRenderFns } from "./PreviewFomer.vue?vue&type=template&id=f4804dca&scoped=true&"
import script from "./PreviewFomer.vue?vue&type=script&lang=js&"
export * from "./PreviewFomer.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFomer.vue?vue&type=style&index=0&id=f4804dca&scoped=true&lang=css&"
import style1 from "./PreviewFomer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4804dca",
  null
  
)

export default component.exports